// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__cie5u","amount":"Amount_amount__VPgEm","tip":"Amount_tip__1WDe_","tipHeader":"Amount_tipHeader__3xuny","tipsWrap":"Amount_tipsWrap__20lRh"};